/**
 * Created by pmnia on 11/11/15.
 */
(function (app) {
    'use strict';

    app.factory('oracleServices', oracleServices);

    /*@ngInject*/
    function oracleServices(queryservice, $q){
        return  {
            domainArgs:null,
            getFallbackPage:getFallbackPage
        };

        function getFallbackPage(data) {

                var args = angular.extend({}, data);
                var fctName= "obtAdvHelper.getFallbackInfo";
                return queryservice.callServer(fctName,args);
            //if(false){}else{
            //    var deferral = $q.defer();
            //    deferral.resolve({page:'therapistClinic', args:{cId:'mblouin6', tId:1}});
            //    return deferral.promise;
            //}
        }
    }
})(angular.module('app.data'));



/*****************
 ** WEBPACK FOOTER
 ** ./app/data/oracle.services.js
 ** module id = 171
 ** module chunks = 0
 **/